import {
  AppData,
  BookingData,
  Organisation,
  Service,
  ServicePage,
  ServiceTier,
  Step,
} from "../../AppDataProvider";

import { Mixpanel } from "../../../mixpanel";
import { PartRequired } from "../../../utils/types";
import { requireBookingDataFields } from "../../../utils/requireBookingDataFields/requireBookingDataFields";
import { TierPricingType } from "../../../GeneratedGraphQL";

export type BackFromResourcesStepOpts = { appData: AppData };

const getPreviousStep = (
  forceServiceSelection: boolean,
  organisation: Organisation,
  service: Service,
  services: ServicePage,
  tier?: ServiceTier,
): Step => {
  const isMultiTier = service.tiers && service.tiers.length > 0;

  const isMultiTierSinglePriceType =
    isMultiTier && tier && tier.pricingType === TierPricingType.Single;
  const isMultiTierMultiplePriceType =
    isMultiTier && tier && tier.pricingType === TierPricingType.Multiple;

  const filteredServices = services.edges.filter(
    ({ node }) => node.organisation._id === organisation?._id,
  );

  if (!organisation.resourceSelectionBeforeAvailability) {
    return "availability";
  }

  if (isMultiTierMultiplePriceType) {
    return "pricePoints";
  } else if (isMultiTierSinglePriceType) {
    return "multiTier";
  }

  if (forceServiceSelection || filteredServices.length !== 1) {
    return "services";
  } else {
    return "organisations";
  }
};

export const backFromResourcesStep = (
  options: BackFromResourcesStepOpts,
): AppData => {
  Mixpanel.track({ name: "Went back", props: { from: "resources" } });

  const { bookingData, bookingTool } = options.appData;

  requireBookingDataFields<
    PartRequired<BookingData, "organisation" | "service">
  >(bookingData, ["organisation", "service"]);

  const { organisation, service, tier } = bookingData;
  const { services, forceServiceSelection } = bookingTool;

  const nextStep = getPreviousStep(
    forceServiceSelection,
    organisation,
    service,
    services,
    tier,
  );

  // Clear the currently selected timeslot if one is present.
  delete options.appData.bookingData.selectedTimeSlot;

  return { ...options.appData, currentStep: nextStep };
};
